import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div<{ isFetching?: boolean }>`
  margin: 20px 0;
  background: ${props => props.theme.palette.general.light};
  ${props => props.isFetching && `
    cursor: wait;
    > * {
      pointer-events: none;
    }
  `}

  > div {
    width: 100%;
    max-width: ${props => props.theme.maxWidth};
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    ${bp('lg')`
      flex-wrap: wrap;
      justify-content: space-between;
    `}
  }
`

export const LayeredNavButton = styled.div`
  box-sizing: border-box;
  display: none;
  ${bp('lg')`
    display: block;
    order: 1;
  `}

  button {
    cursor: pointer;
    padding: 10px;
    font-size: 16px;
    line-height: 1;
    color: ${props => props.theme.palette.general.strong};
    background: ${props => props.theme.palette.general.light};
    border: 1px solid ${props => props.theme.palette.general.greyLight};
    outline: none;
  }
`

export const TotalCountContainer = styled.div`
  display: block;
  box-sizing: border-box;
  color: ${props => props.theme.palette.general.grey};
  font-size: 16px;
  ${bp('lg')`
    order: 2;
  `}
`

export const SorterContainer = styled.div`
  width: 160px;
  margin: 0 0 0 25px;
  box-sizing: border-box;
  ${bp('lg')`
    display: flex;
    justify-content: flex-end;
    order: 3;
    margin: 0;
  `}

  > div {
    width: 100%;
  }
`

export const PaginationContainer = styled.div`
  margin: 0 0 0 25px;
  box-sizing: border-box;
  ${bp('lg')`
    display: flex;
    justify-content: center;
    order: 4;
    width: 100%;
    margin: 20px 0 0;
  `}
`
